<template>
    
</template>

<script>
    export default {
        name: "persona"
    }
</script>

<style scoped>

</style>